import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { IconBundleBlueprint } from '@backstage/plugin-app-react';

// MUI icon imports — mirror the list in
// @backstage/plugin-app/dist/packages/app-defaults/src/defaults/icons.esm.js
// but passed as JSX *elements* (<Icon />) rather than component *references*
// (Icon), which is what the new DefaultIconsApi expects.
import ApartmentIcon from '@material-ui/icons/Apartment';
import BrokenImageIcon from '@material-ui/icons/BrokenImage';
import CategoryIcon from '@material-ui/icons/Category';
import CreateNewFolderIcon from '@material-ui/icons/CreateNewFolder';
import SubjectIcon from '@material-ui/icons/Subject';
import SearchIcon from '@material-ui/icons/Search';
import ChatIcon from '@material-ui/icons/Chat';
import DashboardIcon from '@material-ui/icons/Dashboard';
import DescriptionIcon from '@material-ui/icons/Description';
import EmailIcon from '@material-ui/icons/Email';
import ExtensionIcon from '@material-ui/icons/Extension';
import GitHubIcon from '@material-ui/icons/GitHub';
import HelpIcon from '@material-ui/icons/Help';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import MemoryIcon from '@material-ui/icons/Memory';
import MenuBookIcon from '@material-ui/icons/MenuBook';
import PeopleIcon from '@material-ui/icons/People';
import PersonIcon from '@material-ui/icons/Person';
import WarningIcon from '@material-ui/icons/Warning';
import StorageIcon from '@material-ui/icons/Storage';
import FeaturedPlayListIcon from '@material-ui/icons/FeaturedPlayList';
import StarIcon from '@material-ui/icons/Star';
import StarBorderIcon from '@material-ui/icons/StarBorder';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';

/**
 * Overrides all default Backstage icon registrations with JSX *elements*
 * (<Icon fontSize="inherit" />) instead of component references (Icon).
 *
 * Background: @backstage/plugin-app ships its default icon bundle as component
 * references, which triggers a deprecation warning in DefaultIconsApi:
 *   "The following icons were registered as IconComponent, which is deprecated.
 *    Use IconElement instead by passing <MyIcon /> rather than MyIcon: ..."
 *
 * The IconsApi merges all IconBundleBlueprint contributions over the defaults,
 * so providing the same keys here with JSX elements silences the warning.
 */
const iconBundle = IconBundleBlueprint.make({
    name: 'app-defaults-override',
    params: {
        icons: {
            brokenImage:          <BrokenImageIcon fontSize='inherit' />,
            catalog:              <MenuBookIcon fontSize='inherit' />,
            scaffolder:           <CreateNewFolderIcon fontSize='inherit' />,
            techdocs:             <SubjectIcon fontSize='inherit' />,
            search:               <SearchIcon fontSize='inherit' />,
            chat:                 <ChatIcon fontSize='inherit' />,
            dashboard:            <DashboardIcon fontSize='inherit' />,
            docs:                 <DescriptionIcon fontSize='inherit' />,
            email:                <EmailIcon fontSize='inherit' />,
            github:               <GitHubIcon fontSize='inherit' />,
            group:                <PeopleIcon fontSize='inherit' />,
            help:                 <HelpIcon fontSize='inherit' />,
            'kind:api':           <ExtensionIcon fontSize='inherit' />,
            'kind:component':     <MemoryIcon fontSize='inherit' />,
            'kind:domain':        <ApartmentIcon fontSize='inherit' />,
            'kind:group':         <PeopleIcon fontSize='inherit' />,
            'kind:location':      <LocationOnIcon fontSize='inherit' />,
            'kind:system':        <CategoryIcon fontSize='inherit' />,
            'kind:user':          <PersonIcon fontSize='inherit' />,
            'kind:resource':      <StorageIcon fontSize='inherit' />,
            'kind:template':      <FeaturedPlayListIcon fontSize='inherit' />,
            user:                 <PersonIcon fontSize='inherit' />,
            warning:              <WarningIcon fontSize='inherit' />,
            star:                 <StarIcon fontSize='inherit' />,
            unstarred:            <StarBorderIcon fontSize='inherit' />,
            externalLink:         <OpenInNewIcon fontSize='inherit' />,
        },
    },
});

export const iconsModule = createFrontendModule({
    pluginId: 'app',
    extensions: [iconBundle],
});

